import {useMutation, type UseMutationResult} from '@github-ui/react-query'
import {convertIssueToDiscussionMutation as convertIssueToDiscussionMutationQueryId} from '@github-ui/server-persisted-queries'
import type {
  ConvertIssueToDiscussionInput as ServerConvertIssueToDiscussionInput,
  ConvertIssueToDiscussionMutationMutation,
} from '@github-ui/server-persisted-queries/types/convertIssueToDiscussionMutation'

import {issueLifecyclePath, submitIssueLifecycleMutation} from './issue-lifecycle-mutation'

export type ConvertIssueToDiscussionRouteInput = Omit<
  ServerConvertIssueToDiscussionInput,
  'issueId' | 'clientMutationId'
>
export type ConvertIssueToDiscussionMutationResponse = ConvertIssueToDiscussionMutationMutation

export function useConvertIssueToDiscussionMutation({
  owner,
  repository,
  number,
  onCompleted,
  onError,
}: {
  owner: string
  repository: string
  number: number
  onCompleted?: (response: ConvertIssueToDiscussionMutationMutation) => void
  onError?: (error: Error) => void
}): UseMutationResult<ConvertIssueToDiscussionMutationMutation, Error, {input: ConvertIssueToDiscussionRouteInput}> {
  return useMutation({
    mutationFn: ({input}) => submitConvertIssueToDiscussionMutation({owner, repository, number, input}),
    onSuccess: onCompleted,
    onError,
  })
}

export function submitConvertIssueToDiscussionMutation({
  owner,
  repository,
  number,
  input,
}: {
  owner: string
  repository: string
  number: number
  input: ConvertIssueToDiscussionRouteInput
}) {
  return submitIssueLifecycleMutation<ConvertIssueToDiscussionMutationMutation>({
    path: `${issueLifecyclePath(owner, repository, number)}/discussion.json`,
    method: 'POST',
    queryId: convertIssueToDiscussionMutationQueryId,
    input,
    errorMessage: 'Issue conversion mutation failed',
    isSuccess: data => data.convertIssueToDiscussion?.discussion != null,
    payloadErrors: data => data.convertIssueToDiscussion?.errors,
  })
}
